import { countriesAdapter } from '@/adapters/wiki/countries';
import { pagesAdapter } from '@/adapters/wiki/pages';

export const useWikiStore = defineStore({
  id: 'wiki',
  state: () => ({
    countries: [],
  }),
  getters: {},
  actions: {
    fetchCountries() {
      const { locale } = useI18n();

      return useRequest('/pages/type/cms_country_page', {
        query: { limit: 300 },
        headers: { 'accept-language': locale.value },
      }).then((data) => {
        const countriesData = countriesAdapter(data);
        this.countries = countriesData;

        return countriesData;
      });
    },

    fetchPages({
      pageType,
      filter,
      limit = 20,
      offset = 0,
      locale = undefined,
    }) {
      let requestLocale = locale;

      if (!requestLocale) {
        const { locale } = useI18n();
        requestLocale = locale.value;
      }

      return useRequest(`/pages/type/${pageType}`, {
        headers: { 'accept-language': locale },
        query: {
          filter: {
            country_slug: filter.countrySlug,
          },
          limit,
          offset,
        },
      }).then((data) => pagesAdapter(data));
    },
  },
});
